/**
 * トピック表示
 */
import Vue from 'vue'

import * as httpConst from '../../../constants/httpConst'
import * as types from '../../mutation-types/admin-types'
import {ADMIN_TOPIC_RESET_CONDITION, ADMIN_TOPIC_RESET_PAGINATION} from "../../mutation-types/admin-types";

const API_PATH = `${httpConst.ADMIN_ENDPOINT}/topics`

const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0
    },
    condition: {
      content: null,
    },
  }
}

const topic = {
  namespaced: true,
    state: getDefaultState(),
    getters: {
      hasResult: ( state ) => {
        return (state.pagination.total_count > 0)
      },
    },
    actions: {
      index ({ dispatch, commit, state }, { content, page }) {
        dispatch('saveCondition', { content: content })

        const params = {
          content: state.condition.content,
          page: page
        }

        return new Promise((resolve) => {
          Vue.$http.get(API_PATH, { params: params }).then(data => {
            let content = data.content
            commit(types.ADMIN_TOPIC, { content })
            resolve(data.content)
          })
        })
      },
      new () {
        const api_path = `${API_PATH}/new`
        return new Promise((resolve) => {
          Vue.$http.get(api_path).then(data => {
            resolve(data.content)
          })
        })
      },
      create ({ commit }, { params }) {
        return new Promise((resolve) => {
          Vue.$http.post(API_PATH, params).then( data => {
            let content = data.content
            commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
            resolve(content)
          })
        })
      },
      edit ({ commit }, { id }) {
        const api_path = `${API_PATH}/${id}/edit`
        return new Promise((resolve) => {
          Vue.$http.get(api_path).then(data => {
            commit
            resolve(data.content)
          })
        })
      },
      update ({ commit }, { id, params }) {
        const api_path = `${API_PATH}/${id}`
        return new Promise((resolve) => {
          Vue.$http.put(api_path, params).then(data => {
            let content = data.content
            commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
            resolve(content)
          })
        })
      },
      destroy ({ commit }, { id }) {
        const api_path = `${API_PATH}/${id}`
        return new Promise((resolve) => {
          Vue.$http.delete(api_path).then(data => {
            commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
            resolve(data.content)
          })
        })
      },
      saveCondition ({ commit, state }, { content }) {
        const _content = (content !== undefined) ? content : state.condition.content
        const params = { 
          content: _content,
        }
        commit(types.ADMIN_TOPIC_CONDITION, { params })
      },
      resetState ({ commit }) {
        commit(types.ADMIN_TOPIC_RESET_CONDITION)
      },
      resetPagination ({ commit }) {
        commit(types.ADMIN_TOPIC_RESET_PAGINATION)
      },
    },
    mutations: {
      [types.ADMIN_TOPIC_RESET_PAGINATION] ( state ) {
        Object.assign(state.pagination, getDefaultState().pagination)
      },
      [types.ADMIN_TOPIC_RESET_CONDITION] (state) {
        Object.assign(state, getDefaultState())
      },
      [types.ADMIN_TOPIC] (state, { content }) {
        state.pagination = content.pagination
      },
      [types.ADMIN_TOPIC_CONDITION] (state, { params }) {
        state.condition.content = params.content
      }
    },
}

export default topic

